import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, DateRangeCustomFilterEnum, DateRangePicker, FormSelect, getDate, setDateWithTimezone } from '@systemeio/ui';
import AffiliateDashboardInvoices from 'modules/affiliate-dashboard/components/affiliate-dashboard-invoices';
import AffiliateDashboardLeads from 'modules/affiliate-dashboard/components/affiliate-dashboard-leads';
import AffiliateDashboardPayments from 'modules/affiliate-dashboard/components/affiliate-dashboard-payments';
import AffiliateDashboardPromotion from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion';
import AffiliateDashboardVendorSelector from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-selector';
import { AffiliateDashboardLoco } from 'modules/affiliate-dashboard/constants/affiliate-dashboard-loco';
import { useAffiliateDashboardChart } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-chart';
import { useAffiliateDashboardStatistic } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-statistic';
import { useAffiliateDashboardTags } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-tags';
import { AffiliateDashboardFilterInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import AffiliateChart from 'modules/affiliate-program/affiliate/components/affiliate-chart';
import AffiliateStatistic from 'modules/affiliate-program/affiliate/components/affiliate-statistic';
import { AffiliateStatisticDateFilterInterface } from 'modules/affiliate-program/affiliate/types/affiliate-interface';
import { isDefaultFilter } from 'modules/affiliate-program/utils/is-default-filter';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getCurrencySymbol } from 'shared/utils/get-currency-symbol';
import { getMonthDateRange, getToday } from 'shared/utils/get-dates';
const defaultFilter: AffiliateDashboardFilterInterface = {
  dateTill: null,
  dateSince: null,
  vendorId: undefined,
  currency: undefined
};
const AffiliateDashboard: NextPage = () => {
  const $ = _c(93);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [tagsData, setTagsData] = useState(undefined);
  const {
    filter,
    setFilter
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  const {
    data: affiliateTags
  } = useAffiliateDashboardTags();
  const {
    data: affiliateStatistic
  } = useAffiliateDashboardStatistic(filter.vendorId);
  const {
    data: affiliateChart
  } = useAffiliateDashboardChart(filter);
  const [currencyData, setCurrencyData] = useState();
  let t0;
  let t1;
  if ($[0] !== affiliateStatistic || $[1] !== intlLocale) {
    t0 = () => {
      if (affiliateStatistic) {
        const currencies = Object.keys(affiliateStatistic.total) as CurrencyEnum[];
        setCurrencyData(currencies.map(el => ({
          id: el,
          caption: getCurrencySymbol(el, intlLocale)
        })));
      } else {
        setCurrencyData(undefined);
      }
    };
    t1 = [affiliateStatistic, intlLocale];
    $[0] = affiliateStatistic;
    $[1] = intlLocale;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== affiliateTags) {
    t2 = () => {
      if (affiliateTags) {
        setTagsData(affiliateTags.affiliateTags.map(_temp));
      }
    };
    t3 = [affiliateTags];
    $[4] = affiliateTags;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== t) {
    t4 = t("header.top_menu.affiliate_dashboard");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <h1 className="col-span-2 self-center lg:col-span-1">{t4}</h1>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== affiliateChart || $[12] !== affiliateStatistic || $[13] !== filter || $[14] !== user?.timezone) {
    t6 = !affiliateStatistic || !isDefaultFilter(filter, user?.timezone) && !affiliateChart;
    $[11] = affiliateChart;
    $[12] = affiliateStatistic;
    $[13] = filter;
    $[14] = user?.timezone;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== user?.timezone) {
    t7 = () => getMonthDateRange(user?.timezone);
    $[16] = user?.timezone;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== filter.dateSince || $[19] !== filter.dateTill) {
    t8 = [filter.dateSince, filter.dateTill];
    $[18] = filter.dateSince;
    $[19] = filter.dateTill;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = user?.timezone;
  let t10;
  if ($[21] !== t9) {
    t10 = getToday(t9);
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== setFilter) {
    t11 = date => {
      const newFilterState = {
        dateSince: date[0],
        dateTill: date[1]
      };
      setFilter(prev => ({
        ...prev,
        ...newFilterState
      }));
    };
    $[23] = setFilter;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== user?.affiliateAccountCreatedAt || $[26] !== user?.timezone) {
    t12 = user?.affiliateAccountCreatedAt ? getDate(user?.affiliateAccountCreatedAt, user?.timezone) : undefined;
    $[25] = user?.affiliateAccountCreatedAt;
    $[26] = user?.timezone;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== user) {
    t13 = [{
      slug: DateRangeCustomFilterEnum.AllTime,
      handler: () => {
        const today = setDateWithTimezone("", user?.timezone);
        today.setHours(23, 59, 59, 999);
        if (!user?.affiliateAccountCreatedAt) {
          return [today, today];
        }
        const firstDate = setDateWithTimezone(user.affiliateAccountCreatedAt, user?.timezone);
        return [firstDate, today];
      }
    }];
    $[28] = user;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = user?.timezone;
  const t15 = user?.createdAt;
  let t16;
  if ($[30] !== intlLocale || $[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8) {
    t16 = <DateRangePicker disabled={t6} getDefaultDate={t7} date={t8} maxDate={t10} onChange={t11} minDate={t12} customFilters={t13} timezone={t14} createdAt={t15} intlLocale={intlLocale} />;
    $[30] = intlLocale;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  const t17 = !affiliateStatistic;
  let t18;
  if ($[41] !== t) {
    t18 = t("global.currency");
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== setFilter) {
    t19 = data => setFilter(prev_0 => ({
      ...prev_0,
      currency: data
    }));
    $[43] = setFilter;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== currencyData || $[46] !== filter.currency || $[47] !== t17 || $[48] !== t18 || $[49] !== t19) {
    t20 = <FormSelect disabled={t17} className="max-w-[120px]" data={currencyData} placeholder={t18} value={filter.currency} onChange={t19} />;
    $[45] = currencyData;
    $[46] = filter.currency;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t16 || $[52] !== t20) {
    t21 = <div className="col-span-2 row-start-3 flex flex-wrap justify-end gap-3 sm:col-span-1 sm:row-start-2 lg:row-start-auto lg:flex-nowrap">{t16}{t20}</div>;
    $[51] = t16;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== filter.vendorId || $[55] !== setFilter) {
    t22 = <div className="col-span-2 row-start-2 sm:col-span-1 lg:row-start-auto"><AffiliateDashboardVendorSelector selectedVendor={filter.vendorId} setFilter={setFilter} /></div>;
    $[54] = filter.vendorId;
    $[55] = setFilter;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== affiliateChart || $[58] !== affiliateStatistic?.last30Days || $[59] !== filter || $[60] !== user?.timezone) {
    t23 = isDefaultFilter(filter, user?.timezone) ? affiliateStatistic?.last30Days : affiliateChart;
    $[57] = affiliateChart;
    $[58] = affiliateStatistic?.last30Days;
    $[59] = filter;
    $[60] = user?.timezone;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== affiliateStatistic || $[63] !== filter.currency || $[64] !== t23) {
    t24 = <AffiliateChart affiliateStatistic={affiliateStatistic} selectedCurrency={filter.currency} chartData={t23} />;
    $[62] = affiliateStatistic;
    $[63] = filter.currency;
    $[64] = t23;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  let t26;
  if ($[66] !== filter || $[67] !== setFilter || $[68] !== tagsData) {
    t25 = <div><AffiliateDashboardPayments setMainFilter={setFilter} defaultFilter={defaultFilter} mainFilter={filter} tagsData={tagsData} /></div>;
    t26 = <div><AffiliateDashboardLeads setMainFilter={setFilter} defaultFilter={defaultFilter} mainFilter={filter} tagsData={tagsData} /></div>;
    $[66] = filter;
    $[67] = setFilter;
    $[68] = tagsData;
    $[69] = t25;
    $[70] = t26;
  } else {
    t25 = $[69];
    t26 = $[70];
  }
  let t27;
  if ($[71] !== filter || $[72] !== setFilter) {
    t27 = <div><AffiliateDashboardInvoices mainFilter={filter} setMainFilter={setFilter} /></div>;
    $[71] = filter;
    $[72] = setFilter;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] !== t24 || $[75] !== t25 || $[76] !== t26 || $[77] !== t27) {
    t28 = <div className="col-span-2 flex flex-col gap-5">{t24}{t25}{t26}{t27}</div>;
    $[74] = t24;
    $[75] = t25;
    $[76] = t26;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== affiliateStatistic || $[80] !== filter.currency) {
    t29 = <AffiliateStatistic isDashboard={true} selectedCurrency={filter.currency} affiliateStatistic={affiliateStatistic} />;
    $[79] = affiliateStatistic;
    $[80] = filter.currency;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  const t30 = affiliateStatistic?.user.affiliateAccount.affiliateId;
  let t31;
  if ($[82] !== t30) {
    t31 = <AffiliateDashboardPromotion affiliateId={t30} />;
    $[82] = t30;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== t29 || $[85] !== t31) {
    t32 = <div className="col-span-2 row-start-4 flex flex-col gap-5 sm:row-start-3 lg:col-span-1 lg:row-start-auto">{t29}{t31}</div>;
    $[84] = t29;
    $[85] = t31;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] !== t21 || $[88] !== t22 || $[89] !== t28 || $[90] !== t32 || $[91] !== t5) {
    t33 = <><div className="grid grid-flow-row grid-cols-2 gap-5 lg:grid-cols-3">{t5}{t21}{t22}{t28}{t32}</div></>;
    $[87] = t21;
    $[88] = t22;
    $[89] = t28;
    $[90] = t32;
    $[91] = t5;
    $[92] = t33;
  } else {
    t33 = $[92];
  }
  return t33;
};
export const getServerSideProps = getBaseServerSideProps(AffiliateDashboardLoco, 'header.top_menu.affiliate_dashboard');
export default AffiliateDashboard;
function _temp(el_0) {
  return {
    id: el_0.id,
    caption: el_0.name
  };
}